'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import foundationLoader from '../utils/foundation-loader';
import fullScreenGallery from '../components/full-screen-gallery';
import previewSlider from '../components/preview-slider';
import footerNav from '../components/review/footer-nav';
import videoPlayer from '../components/video-player';
import injectShowHeroesAds from '../utils/inject-show-heroes';
import affiliateLinks from '../utils/affiliate-links';

export function init() {
	const foundationPlugins = [];
	const $faqBlock = $.findByBem('faq-block');
	if ($faqBlock.length > 0) {
		foundationPlugins.push(foundationLoader.PLUGINS.ACCORDION);
	}

	baseInit(foundationPlugins);
	fullScreenGallery.init();
	previewSlider.init();
	footerNav.init();
	videoPlayer.init();
	affiliateLinks.init();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
	injectShowHeroesAds.init('review-details-verdict', 'content');
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}